export type RoleValue = "owner" | "admin" | "veterinary" | "groomer" | "receptionist" | "pet_sitter";
export type EmploymentType = "clt" | "pj" | "autonomo" | "estagio";
export type SalaryPeriod = "monthly" | "biweekly" | "weekly";
export type PermissionFlags = { view: boolean; create: boolean; update: boolean; delete: boolean };

export type TeamMemberRow = {
  user_id: string; full_name: string; email: string | null; cpf: string | null; phone: string | null;
  avatar_url: string | null; job_title: string | null; role_value: RoleValue; is_owner: boolean; terminated_at: string | null;
};

export type TeamMemberDetail = TeamMemberRow & {
  birth_date: string | null; employment_type: EmploymentType | null; hired_at: string | null;
  role_source: "customer" | "clinic"; is_veterinarian: boolean; is_groomer: boolean; is_self: boolean; last_sign_in_at: string | null;
};

export type MemberPermissions = { role_value: RoleValue; effective: Record<string, PermissionFlags>; override_count: number };

export type SalaryHistoryEntry = { amount: number; effective_from: string; reason: "hire" | "raise" | "adjustment" };
export type MemberCompensation = {
  base_salary: number | null; salary_period: SalaryPeriod; salary_payday: number | null; history: SalaryHistoryEntry[];
};

export type FeatureRow = {
  value: string; module: string; can_view: boolean; can_create: boolean; can_update: boolean; can_delete: boolean;
};

export function isActiveMember(member: Pick<TeamMemberRow, "terminated_at">, today = new Date().toISOString().slice(0, 10)): boolean {
  return !member.terminated_at || member.terminated_at > today;
}
